import PropTypes from 'prop-types'
import AbstractForm from '../forms/AbstractForm'
import { Typography } from '../styled'
import theme from '../../constants/theme'

function RadioQuestion({ question, index, setEliminatingAnswers }) {
  const inputs = [
    {
      name: `radio`,
      label: `Q${index}: ${question.question}`,
      renderType: 'radio',
      type: 'radio',
      options: [
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' },
      ],
      required: true,
      width: 12,
    },
  ]

  const handleFormWatch = (value) => {
    if (value.radio !== undefined)
      setEliminatingAnswers((prev) => [
        ...prev.filter((a) => a.id !== question.id),
        {
          id: question.id,
          answer: { radio: value?.radio },
        },
      ])
  }

  return (
    <>
      {' '}
      <p className="mt-4 mb-3">
        <Typography
          size={14}
          bold
          style={{
            backgroundColor: theme.talentinoWhiteBlue,
            color: theme.brandColorOrange,
            borderRadius: '50%',
            padding: '6px',
          }}
        >
          {`Q${index}`}
        </Typography>{' '}
        <Typography
          backgroundColor={theme.cardBorder}
          color={theme.inputField}
          className="mx-1"
        >
          {question.question}
        </Typography>
      </p>
      <AbstractForm
        inputs={inputs}
        handleFormWatch={(value) => handleFormWatch(value)}
      />
    </>
  )
}

export default RadioQuestion

RadioQuestion.defaultProps = {
  setEliminatingAnswers: () => {},
  index: 0,
  question: PropTypes.shape({
    id: '',
    question: '',
    answer_type: '',
    answer: {},
    show: false,
  }),
}

RadioQuestion.propTypes = {
  setEliminatingAnswers: PropTypes.func,
  index: PropTypes.number,
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    answer_type: PropTypes.string.isRequired,

    // eslint-disable-next-line react/forbid-prop-types
    answer: PropTypes.object.isRequired,
    show: PropTypes.bool,
  }),
}
